import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_TOKEN_KEY = "1099er_admin_token";

/**
 * Admin token is intentionally stored in sessionStorage (not localStorage) so it
 * lives only for the current tab session and is discarded when the browser closes.
 * This narrows the XSS-exfiltration window compared to persistent storage.
 * The token is a shared admin secret entered manually — not per-user credentials.
 */
const tokenStore = () =>
    typeof window !== "undefined" ? window.sessionStorage : null;

export const setAdminToken = (token) => {
    const store = tokenStore();
    if (!store) return;
    if (token) store.setItem(ADMIN_TOKEN_KEY, token);
    else store.removeItem(ADMIN_TOKEN_KEY);
};
export const getAdminToken = () => tokenStore()?.getItem(ADMIN_TOKEN_KEY) || "";

const authHeaders = () => {
    const t = getAdminToken();
    return t ? { Authorization: `Bearer ${t}` } : {};
};

// Public
export const submitRep = (payload) => axios.post(`${API}/reps`, payload);
export const submitContact = (payload) => axios.post(`${API}/contact`, payload);

// Admin (token required)
export const verifyAdmin = (token) =>
    axios.post(`${API}/admin/verify`, {}, { headers: { Authorization: `Bearer ${token}` } });
export const listReps = () => axios.get(`${API}/reps`, { headers: authHeaders() });
export const listContacts = () => axios.get(`${API}/contact`, { headers: authHeaders() });
export const adminStats = () => axios.get(`${API}/admin/stats`, { headers: authHeaders() });

export const updateRepStatus = (id, status) =>
    axios.patch(`${API}/reps/${id}/status`, { status }, { headers: authHeaders() });
export const updateContactStatus = (id, status) =>
    axios.patch(`${API}/contact/${id}/status`, { status }, { headers: authHeaders() });

export const downloadRepsCsv = () =>
    axios.get(`${API}/reps/export`, { headers: authHeaders(), responseType: "blob" });
export const downloadContactsCsv = () =>
    axios.get(`${API}/contact/export`, { headers: authHeaders(), responseType: "blob" });
